export default {"src":"/_next/static/media/arrow-up.25ecb750.svg","height":12,"width":12};